import { IProps } from '@/Interfaces/Icons/Props.interface';

const FirstPartyDataIcon = ({ className, ...props }: IProps) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.46038 7.28344C9.40301 5.82691 11.0427 4.86133 12.9091 4.86133C15.7228 4.86133 18.024 7.05583 18.1944 9.82665C18.2506 9.82451 18.307 9.82343 18.3636 9.82343C20.7862 9.82343 22.75 11.7873 22.75 14.2098C22.75 16.6323 20.7862 18.5962 18.3636 18.5962L7 18.5962C3.82436 18.5962 1.25 16.0218 1.25 12.8462C1.25 9.67052 3.82436 7.09616 7 7.09616C7.50391 7.09616 7.99348 7.16115 8.46038 7.28344ZM15.0856 12.4681C14.8269 12.7915 14.3549 12.844 14.0314 12.5852L12.75 11.5601V14.9996C12.75 15.4138 12.4142 15.7496 12 15.7496C11.5858 15.7496 11.25 15.4138 11.25 14.9996V11.56L9.96849 12.5852C9.64504 12.844 9.17307 12.7915 8.91431 12.4681C8.65556 12.1446 8.708 11.6727 9.03145 11.4139L11.5288 9.41606C11.656 9.31317 11.8176 9.25105 11.9937 9.2496L12 9.24957L12.0024 9.24958C12.1815 9.25014 12.3459 9.31349 12.4745 9.41877L14.9685 11.4139C15.2919 11.6727 15.3444 12.1446 15.0856 12.4681Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default FirstPartyDataIcon;
